<template>
  <div class="job-list" v-if="loadedCompany">
    <!-- has_custom_mobile_landing_page 这个功能已对所有公司开放，不再需要下面这个样式了
    <div
      v-if="!has_custom_mobile_landing_page"
      class="page-wrapper js-wechat-share-page more-jobs-wrapper"
      v-show="showMoreJobsWrapper">
      <\!-- We may add job search for apple --\>
      <div v-if="company.id !== 87" class="search-btn-container" @click="onSearchBtnIconClick">
        <span class="search-button"></span>
      </div>
      <div class="nav-bar">
        <NavBar
          :account="account"
          :company="company"
          :showNavBar="showNavBar"
          :showHolder="true"
          :isHiddenHome="true"
          :currentPage="1"
          @afterPopupClosed="showNavBar=false"></NavBar>
      </div>
      <div class="company">
        <a :href="$DjangoBaseUrl(`/company-detail-new/${company.id}/`)">
          <img v-if="company.logo" class="company-img" :src="$DjangoBaseUrl(company.logo)" />
          <img v-else class="company-img" :src="$DjangoStaticUrl(`images_en/default_company.jpg`)" />
        </a>
        <div class="company-info">
          <div class="company-name">{{ languageCode === 'en' ? company.name : company.cn_name }}</div>
        </div>
      </div>
    </div> -->

    <MobilePersonalMenu
      v-model="showNavBar"
      :company="company"
      :hideReferralProgram="hideReferralProgram"
      :hasLogin="hasLogin"
      :isEmployeeAccount="isEmployeeAccount"
      :hideCompanyMenu="!has_custom_mobile_landing_page"
    />

    <ListSearch
      ref="ListSearch"
      :has_custom_mobile_landing_page="true"
      :header_image="header_image"
      :default_header_image="default_header_image"
      :search="search"
      :qiniu_domain="qiniu_domain"
      :company="company"
      :account="account"
      :company_webpage_title="company_webpage_title"
      :slogan="slogan"
      :showSalary="showSalary"
      :hide_trading_area="hide_trading_area"
      :searchOverlay="searchOverlay"
      :company_job_filter="company_job_filter"
      :company_job_filter_items="company_job_filter_items"
      :isSearching="isSearching"
      :hasCustomFilter="hasCustomFilter"
      :show_survey_entrance="show_survey_entrance"
      :has_answered="has_answered"
      :showShareBtn="job_list_type === 'flat'"
      :personalAgreementStatus="personalAgreementStatus"
      :surveyInfo="surveyInfo"
      @onMenuIconClick="onMenuIconClick"
      @clearSearch="clearSearch"
      @fetchJobList="fetchJobList"
      @showWrapper="showWrapper"
      @showListLoading="showListLoading"
      @share="onMenuShareBtnClick"
    />

    <div
      ref="jobListContent"
      class="job-list-content list-view-container active-container referral-wrapper animated-page"
      :class="job_list_type === 'flat' ? 'flat-company' : ''"
    >
      <template v-if="hasJobs">
        <CustomedCompanyJobList
          v-if="job_list_type === 'customed'"
          :company="company"
          :data="jobList"
          :showJobs="showJobs"
        />
        <!-- batch sharing only support flat list -->
        <FlatCompanyJobList
          v-else-if="job_list_type === 'flat'"
          :company="company"
          :data="jobList"
          :showSalary="showSalary"
          :enable-select="batchSharing.enable"
          :selected.sync="batchSharing.selected"
        />
        <DefaultCompanyJobList
          v-else
          :company="company"
          :data="jobList"
          :showSalary="showSalary"
          :has_referral_word_customized="has_referral_word_customized"
        />
      </template>
      <div v-else class="no-result">
        <div class="talent-opportunity">
          <span class="talent">{{ $t('companyJobList.talent') }}</span>
          <span class="opportunity">{{ $t('companyJobList.opportunity') }}</span>
        </div>
        <div class="tip">
          <p>{{ $t('companyJobList.tip.noJobMatched') }}</p>
          <p>{{ $t('companyJobList.tip.tryOtherKeywords') }}</p>
        </div>
      </div>
      <template v-if="showLoading">
        <template v-if="4335 == company.root_company.id">
          <div class="loading-cycle more-jobs-loading-cycle" :style="loadingCycle ? 'display: block' : 'display: none'"></div>
        </template>
        <template v-else>
          <div class="company-job-list-loading">
            <RectLoading v-show="loadingCycle"/>
          </div>
        </template>
      </template>
    </div>
    <div v-if="has_custom_mobile_landing_page" class="costum-mobile-footer">
      <template v-if="!has_custom_mobile_landing_page_2">
        <div class="about-us col-2">
          <router-link :to="brandingUrl">{{ about_us }}</router-link>
        </div>
        <div class="view col-2 company-customized active-color" :class="!has_custom_mobile_landing_page && 'full-line'">
          {{ $t('companyJobList.viewJobs') }}
        </div>
      </template>
      <template v-else>
          <div class="about-us col-3">
            <router-link :to="brandingUrl">{{ about_us }}</router-link>
          </div>
          <div class="group col-3">
            <router-link :to="landingUrl">{{ group }}</router-link>
          </div>
        <div class="view col-3 company-customized active-color" :class="!has_custom_mobile_landing_page && 'full-line'">
          {{ $t('companyJobList.viewJobs') }}
        </div>
      </template>
    </div>
    <transition name="fade">
      <div v-if="batchSharing.enable" class="batch-sharing-container">
        <div class="all-job-checkbox">
          <van-checkbox v-model="batchSharing.isSelectAll" @click="resetSelectedJobs">{{ $t('common.all') }}</van-checkbox>
        </div>
        <div class="share-btn-group">
          <el-button v-show="batchSharing.hasSelectAny" round class="clear-btn" @click="handleCancelShareBtnClick">{{ $t('common.btn.cancel') }}</el-button>
          <el-button round class="share-btn" :class="!batchSharing.hasSelectAny && 'disabled-btn'" @click="handleShareBtnClick">{{ $t('common.btn.share') }}</el-button>
        </div>
      </div>
    </transition>
    <SharePopup
      :show.sync="sharePopup.show"
      :companyLogoPath="$DjangoBaseUrl(company.logo)"
      :companyId="company.id"
      :rootCompanyId="company.root_company.id"
      :companyName="companyName"
      :weChatShareMomentTitle="weChatShareMomentTitle"
      :shareLink="sharePopup.link"
      :shareJobs="sharePopup.shareJobs"
      :isShareAllJobs="sharePopup.isShareAllJobs"
      :companyHasJobPoster="companyHasJobPoster"
      :cityName="search.cityName"
      isInChina
    />
    <Chatbot
      v-if="(show_chatbot || showAiChatbot) && !sharePopup.show"
      v-show="!hiddenChatbot"
      class="chatbot"
      :useAiChatbot="showAiChatbot"
      :generateUserId="user_id"
      :currentAccountId="currentAccount?.id"
      :showChatbotMessageBox="showChatbotMessageBox"
      :company="company"
    />
    <VideoNavigation
      v-if="video_navigation?.video_list?.length > 0"
      class="video-navigation"
      :class="(show_chatbot || showAiChatbot) && 'has-chatbot'"
      :data="video_navigation.video_list"
      @videoNavigationShowChange="onVideoNavigationShowChange"
    />
    <van-overlay
      :show="searchOverlay.show"
      :z-index="searchOverlay.zIndex"
      @click="searchOverlay.show = false; searchOverlay.onClose()"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Optional from 'optional-js'
import _ from 'lodash'
import CustomedCompanyJobList from '@/components/job/list/CustomedCompanyJobList.vue'
import FlatCompanyJobList from '@/components/job/list/FlatCompanyJobList.vue'
import DefaultCompanyJobList from '@/components/job/list/DefaultCompanyJobList.vue'
import ListSearch from '@/components/job/list/ListSearch.vue'
import Chatbot from '@/components/job/chatbot'
import MobilePersonalMenu from '@/components/menu/mobilePersonalMenu.vue'
import SharePopup from '@/components/job/list/sharePopup.vue'
import VideoNavigation from '@/components/videoNavigation/videoNavigation.vue'
import {
  QINIU_DOMAIN,
  CUSTOM_MOBILE_LANDING_CUSTOMIZED_COLOR,
  CUSTOMIZATION_REFERRAL_WORD,
  HIDE_REFERRAL_COMPANY_IDS,
  HIDE_TRADING_AREA,
  HIDDEN_SALARY_COMPANY_IDS,
  COLOR_CUSTOMIZED_COMPANY_IDS
} from '@/constant/common'
import configWxShare, { refreshShareParam, configWeComShare } from '@/utils/wxShareConfig'
import RectLoading from '@/components/loading/rectLoading'
import { getCurrentCityName } from '@/utils/amap'
import { deviceType, addQueryInPath, computedColorLuminance } from '@/utils/common'
import { getI18nPropertyValue } from '@/i18n'

export default {
  components: {
    CustomedCompanyJobList,
    FlatCompanyJobList,
    DefaultCompanyJobList,
    ListSearch,
    Chatbot,
    RectLoading,
    MobilePersonalMenu,
    SharePopup,
    VideoNavigation
  },
  props: {
    isMSDCustom: {
      type: Boolean,
      default: false
    },
    customCompanyId: {
      required: false
    }
  },
  metaInfo () {
    return {
      link: this.metaInfoLinkList,
      style: this.metaInfoStyleList
    }
  },
  data () {
    return {
      loadedCompany: false,
      company: {
        has_referral_word_customized: false,
        show_equivalent_reward: false,
        name: '',
        cn_name: '',
        hide_parent_company_nav_bar: false,
        i18n_name: '',
        is_overseas_company: false,
        logo: '',
        root_company: {}
      },
      has_custom_mobile_landing_page_2: false,
      qiniu_domain: QINIU_DOMAIN,

      account: {
        employee: null
      },
      softUser: null,
      jobList: [],
      search: {
        keywords: null,
        cityName: null
      },
      respFilterCurrentCity: null,

      // pageSettings: {
      about_us: '',
      color: '',
      company_logo: '',
      company_webpage_title: '',
      custom_mobile_landing_customized_color: false,
      flat_customized: false,
      has_color_customization: false,
      has_custom_mobile_landing_page: false,
      has_referral_word_customized: false,
      header_image: '',
      default_header_image: null,
      hide_referral_flag: false,
      hide_trading_area: false,
      job_list_type: '',
      menu_name: '',
      normalShareUrl: '',
      show_chatbot: false,
      showSalary: true,
      slogan: '',
      wechat_share_info: '',
      hasCustomFilter: false,
      company_job_filter: [],
      company_job_filter_items: {},

      wxShareInfo: {},
      referralShareUrl: null,
      showNavBar: false,
      showLoading: false,
      loadingCycle: false,
      hasJobs: true,
      showJobs: true,
      totalPage: 1,
      pageNum: 1,
      isLastPage: false,
      searchOverlay: {
        show: false,
        zIndex: 1,
        onClose: () => {}
      },
      showMoreJobsWrapper: false,
      hasSetHashParams: false,
      isSearching: false,
      user_id: '',
      showChatbotMessageBox: false,
      show_survey_entrance: false,
      custom_color: null,
      metaInfoStyleList: [],
      metaInfoLinkList: [],
      has_answered: false,
      companyDataLoader: null,
      batchSharing: {
        enable: false,
        isSelectAll: false,
        selected: {},
        get hasSelectAny () {
          return this.isSelectAll || _.findKey(this.selected)
        }
      },
      sharePopup: {
        show: false,
        link: '',
        shareJobs: [],
        isShareAllJobs: false
      },
      video_navigation: null,
      hiddenChatbot: false,
      personalAgreementStatus: null,
      surveyInfo: {},
      showAiChatbot: false
    }
  },
  computed: {
    ...mapGetters('account', ['isCandidateAccount']),
    brandingUrl () {
      const path = this.isMSDCustom ? '/msdchina/about' : `/recruiting/company/${this.company.id}/branding`
      return { path: path, query: this.$route.query }
    },
    landingUrl () {
      const path = this.isMSDCustom ? '/msdchina/careers' : `/recruiting/company/${this.company.id}/landing`
      return { path: path, query: this.$route.query }
    },
    languageCode () {
      return this.$i18n.locale
    },
    hideReferralProgram () {
      const account = this.getCurrentAccount()
      return Boolean(account?.employee?.company.hide_referral_program)
    },
    hasLogin () {
      const account = this.getCurrentAccount()
      return Boolean(account?.id)
    },
    isEmployeeAccount () {
      const account = this.getCurrentAccount()
      return Boolean(account?.employee?.id)
    },
    companyId () {
      return this.customCompanyId || this.$route.params.companyId
    },
    companyName () {
      return getI18nPropertyValue(this.company, 'cn_name', 'name')
    },
    companyHasJobPoster () {
      return this.company?.premium?.job_poster
    },
    weChatShareMomentTitle () {
      return this.wxShareInfo?.moment_title || this.companyName
    },
    shareJobLoginFail () {
      return !this.hasLogin && this.$route.query.code_fail === '1' && this.$route.query.is_job_share_login === '1'
    },
    currentAccount () {
      return this.getCurrentAccount()
    }
  },
  async created () {
    this.$eventBus.$emit('showLoading', true)
    try {
      const account = this.getCurrentAccount()
      if (account.device === 'pc') {
        location.href = this.$DjangoBaseUrl(`/company-detail-new/${this.companyId}/${location.search}${location.hash}`)
        return
      }
      this.search.ipCityName = await getCurrentCityName()
      this.account = account
      this.softUser = this.getCurrentSoftUser()
      this.trackCandidateViewJobList({ company_id: this.companyId })
      this.initQueryParams()
      this.setQueryParamsCBDInfo()
      this.getGeolocation(this.fetchJobList)
      this.initPersonalAgreementStatus()
      this.initSurveyInfo()
      await this.initCompanyData()
    } finally {
      this.$eventBus.$emit('showLoading', false)
      if (this.shareJobLoginFail) {
        this.$message({
          type: 'warning',
          message: this.$t('common.message.shareJobLoginFail')
        })
      }
    }
  },
  beforeDestroy () {
    // 在页面为未加载完成时返回上一页，导致loading未关闭，在页面销毁时再次关闭loading
    this.$eventBus.$emit('showLoading', false)
    window.removeEventListener('scroll', this.scrollBottom)
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount', 'getCurrentSoftUser']),
    ...mapActions('job', ['searchCompanyJobList']),
    ...mapActions('company', ['getCompanyBaseInfo', 'getCustomJobListPageInfo']),
    ...mapActions('common', ['getWxApiTicket']),
    ...mapActions('joywok', ['checkAutoLogin', 'getEmployeeInfo', 'getJoywokConfigParams']),
    ...mapActions('account', ['getSessionAccountInfo']),
    ...mapActions('referral', ['startListReferral']),
    ...mapActions('personal', ['getAgreementStatus']),
    ...mapActions('survey', ['getSurveyInfo']),
    ...mapActions('eventTrack', ['trackCandidateViewJobList', 'trackCandidateShareJobList']),
    getGeolocation (callback) {
      let hasSearch = false
      const timeout = setTimeout(() => {
        hasSearch = true
        callback()
      }, 1300)
      navigator.geolocation.getCurrentPosition(position => {
        this.search.lng = position.coords.longitude
        this.search.lat = position.coords.latitude
        clearTimeout(timeout)
        callback()
      }, () => {
        if (hasSearch) {
          return
        }
        clearTimeout(timeout)
        callback()
      }, {
        enableHighAccuracy: true,
        maximumAge: 5000,
        timeout: 1000
      })
    },
    initQueryParams () {
      const hashStr = decodeURIComponent(this.$route.hash)
      const paramArr = hashStr.substring(1).split('&')
      const params = {}
      const customFilters = []
      for (const paramItem of paramArr) {
        const param = paramItem.split('=')
        const paramName = param[0]
        if (param.length > 1) {
          if (paramName.startsWith('custom_filter_')) {
            const customFilterId = paramName.replace('custom_filter_', '')
            customFilters.push({
              id: customFilterId,
              value: param[1]
            })
          } else {
            params[paramName] = param[1]
          }
        } else {
          params[paramName] = null
        }
      }
      this.search.keywords = params.keywords
      this.search.type = params.type
      this.search.jobIndustryId = params.ji || 0
      this.search.jobTypeId = params.jt || 0
      this.search.jobSalaryId = params.js
      this.search.jobWorkTimeId = params.jwt
      this.search.roleType = params.rt
      this.search.areaCityId = params.city
      this.search.areaRegionId = params.region
      this.search.areaId = params.area
      this.search.refj = params.refj
      this.search.orderBy = params.order_by
      this.search.jtitle = params.jtitle
      this.search.jobExperience = params.jexp
      this.showChatbotMessageBox = params.chatbot === '1' || params.chatbot === 1
      this.search.jobIds = params.jid
      if (customFilters.length > 0) {
        this.search.customFilters = customFilters
      }
    },
    setQueryParamsCBDInfo () {
      const city = this.search.areaCityId === null ? null : Number(this.search.areaCityId)
      const region = this.search.areaRegionId === null ? null : Number(this.search.areaRegionId)
      const area = this.search.areaId === null ? null : Number(this.search.areaId)
      const CBDInfo = {
        city: city,
        region: region,
        area: area
      }
      sessionStorage.setItem('cbd', JSON.stringify(CBDInfo))
    },
    setFilterCityName () {
      if (this.loadedCompany && this.respFilterCurrentCity) {
        this.$nextTick(() => {
          this.$eventBus.$emit('setFilterCity', this.respFilterCurrentCity)
          this.search.areaCityId = this.respFilterCurrentCity.id
          this.setQueryParams()
          this.respFilterCurrentCity = null
        })
      }
    },
    async initCompanyData () {
      const companyId = parseInt(this.companyId)
      this.companyDataLoader = Promise.all([
        this.loadCompanyBaseInfo(),
        this.getCustomJobListPageInfo({ company_id: companyId }),
        this.configReferral()
      ])
      const respList = await this.companyDataLoader
      _.forEach(respList, resp => {
        _.forEach(resp, (value, key) => {
          this[key] = value
        })
      })

      if (this.job_list_type === 'flat' && true) {
        this.flat_customized = true
      }
      this.hasCustomFilter = Boolean(this.has_custom_filter)
      const company = this.company
      if (!company.root_company || !company.root_company.id) {
        const rootCompany = {
          ...company
        }
        delete rootCompany.root_company
        company.root_company = rootCompany
      }
      this.company = company
      const rootCompanyId = company.root_company.id
      this.wxShareInfo = JSON.parse(this.wechat_share_info)
      this.wxShareInfo.success = () => {
        this.trackCandidateShareJobList({
          company_id: companyId
        })
      }
      if (this.referralShareUrl) {
        this.wxShareInfo.normal_share_url = this.referralShareUrl
      }
      if (this.wxShareInfo && this.wxShareInfo.is_activated) {
        this.$eventBus.$emit('setCustomTitle', this.wxShareInfo.moment_title)
      } else {
        this.$eventBus.$emit('setCustomTitle', this.$t('companyJobList.title'))
      }
      this.has_referral_word_customized = CUSTOMIZATION_REFERRAL_WORD.indexOf(rootCompanyId) > -1
      this.hide_referral_flag = HIDE_REFERRAL_COMPANY_IDS.indexOf(companyId) > -1 || HIDE_REFERRAL_COMPANY_IDS.indexOf(rootCompanyId) > -1
      this.hide_trading_area = HIDE_TRADING_AREA.indexOf(companyId) > -1 || HIDE_TRADING_AREA.indexOf(rootCompanyId) > -1
      this.showSalary = HIDDEN_SALARY_COMPANY_IDS.indexOf(rootCompanyId) < 0
      await this.initPageCss()
      if (deviceType.isWeChatWork) {
        const wxShareInfo = this.wxShareInfo
        wxShareInfo.image_url = window.location.origin + wxShareInfo.logo
        wxShareInfo.link = wxShareInfo.normal_share_url || window.location.href
        configWeComShare(this.wecom_app_info, wxShareInfo)
      } else {
        configWxShare(this, null, rootCompanyId, companyId)
      }
      // this.checkStarbucksSSO()
      this.loadedCompany = true
      this.$nextTick(() => {
        this.$refs.ListSearch.$el.addEventListener('animationend', () => {
          this.$refs.ListSearch.$el.classList.remove('animated', 'fadeInUpBig')
        })
        this.$refs.jobListContent.addEventListener('animationend', () => {
          this.$refs.jobListContent.classList.remove('animated', 'fadeInUpBig')
        })
      })
    },
    async initPersonalAgreementStatus () {
      if (!this.hasLogin || !this.isCandidateAccount) {
        return
      }
      const resp = await this.getAgreementStatus({
        company_id: this.companyId
      })
      if (resp) {
        this.personalAgreementStatus = resp
      }
    },
    async initSurveyInfo () {
      if (!this.hasLogin || !this.isCandidateAccount) {
        return
      }
      const resp = await this.getSurveyInfo(this.companyId)
      if (resp) {
        this.surveyInfo = resp
      }
    },
    initPageCss () {
      const company = this.company
      const rootCompanyId = company.root_company ? company.root_company.id : company.id
      if (CUSTOM_MOBILE_LANDING_CUSTOMIZED_COLOR[rootCompanyId]) {
        this.color = CUSTOM_MOBILE_LANDING_CUSTOMIZED_COLOR[rootCompanyId]
        this.custom_mobile_landing_customized_color = true
      } else {
        this.color = null
        this.custom_mobile_landing_customized_color = false
      }
      const hasColorCustomization = this.has_color_customization
      const hasCustomMobileLandingPage = true
      const customMobileLandingCustomizedColor = this.custom_mobile_landing_customized_color
      const flatCustomized = this.flat_customized
      const showChatbot = this.show_chatbot
      const customCompanyColor = this.color || this.custom_color
      let baseUrl = process.env.VUE_APP_STYLE_BASE_URL
      if (baseUrl.endsWith('/')) {
        baseUrl = baseUrl.substring(0, baseUrl.length - 1)
      }
      const linkList = [
        {
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/style_common.css?_t=${Date.now()}`
        },
        {
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/style_zh.css?_t=${Date.now()}`
        }
      ]
      const styleList = []
      if (COLOR_CUSTOMIZED_COMPANY_IDS.indexOf(rootCompanyId) > -1) {
        linkList.push({
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/company_${rootCompanyId}_customized.css?_t=${Date.now()}`
        })
        if (rootCompanyId === 4335) {
          linkList.push({
            rel: 'stylesheet',
            href: `${baseUrl}/static/style/mobile_web/marketing_honeywell.css?_t=${Date.now()}`
          })
        }
      }
      if (hasColorCustomization) {
        linkList.push({
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/mobile_color_customization.css?_t=${Date.now()}`
        })
      }
      if (hasCustomMobileLandingPage) {
        linkList.push({
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/mobile_web/company_landing_page_customized.css?_t=${Date.now()}`
        })
      }
      if (showChatbot) {
        linkList.push({
          rel: 'stylesheet',
          href: `${baseUrl}/static/style/henkel-bot.css?_t=${Date.now()}`
        })
      }

      if (customMobileLandingCustomizedColor) {
        styleList.push(`
          .company-customized, .company-customized span {
            color: ${this.color} !important;
          }
        `)
      }
      if (flatCustomized) {
        styleList.push(`
          #main .customed.page-wrapper + .list-view-container.job-list-content {
            margin-top: -12px;
          }
        `)
      }
      if (customCompanyColor) {
        const textColor = this.getActiveColorByCustomColor(customCompanyColor)
        styleList.push(`
          body {
            --custom-color: ${customCompanyColor};
            --text-color: ${textColor};
          }
        `)
        styleList.push(`
          .job-list .company-job-list-loading .rect-loading.loading-mask .loading-spinner .spinner > div {
            background-color: ${customCompanyColor};
          }
        `)
      }
      const metaInfoStyleList = [
        {
          innerHTML: styleList.join('\n')
        }
      ]
      const allPromise = _.map(metaInfoStyleList.concat(linkList), item => {
        return new Promise((resolve, reject) => {
          item.callback = resolve
        })
      })
      this.metaInfoLinkList = linkList
      this.metaInfoStyleList = metaInfoStyleList
      return Promise.all(allPromise)
    },
    async loadCompanyBaseInfo () {
      const companyId = parseInt(this.companyId)
      const query = this.$route.query
      const resp = await this.getCompanyBaseInfo({
        id: companyId,
        params: {
          aj_source: query.aj_source,
          aj_code: query.aj_code,
          is_job_list: true
        }
      })
      this.showAiChatbot = resp.show_ai_chatbot
      _.forEach(resp, (value, key) => {
        this[key] = value
      })
    },
    showListLoading (show) {
      this.showLoading = show
      this.loadingCycle = show
    },
    encodeParam (value) {
      return (value && typeof value === 'string')
        ? value.replace(/&/, encodeURIComponent('&'))
          .replace(/#/, encodeURIComponent('#'))
          .replace(/=/, encodeURIComponent('='))
        : value
    },
    serialize (obj, prefix) {
      const str = []
      for (const p in obj) {
        const key = prefix ? prefix + '[' + p + ']' : p; const value = obj[p]
        str.push(typeof value === 'object'
          ? this.serialize(value, key)
          : key + '=' + this.encodeParam(value))
      }
      return str.join('&')
    },
    setQueryParams (customized) {
      const PAGE_SIZE = 10
      const params = {
        page: this.pageNum,
        page_size: PAGE_SIZE,
        keywords: this.search.keywords || '',
        type: this.search.type || '',
        ji: this.search.jobIndustryId || 0,
        jt: this.search.jobTypeId || 0,
        js: this.search.jobSalaryId || '',
        jwt: this.search.jobWorkTimeId || '',
        rt: this.search.roleType || '',
        city: this.search.areaCityId || '',
        region: this.search.areaRegionId || '',
        area: this.search.areaId || '',
        refj: this.search.refj || '',
        jtitle: this.search.jtitle || '',
        order_by: this.search.orderBy || '',
        experience_required: this.search.jobExperience || '',
        jid: this.search.jobIds || ''
      }
      if (this.search.customFilters && this.search.customFilters.length > 0) {
        _.forEach(this.search.customFilters, item => {
          params[`custom_filter_${item.id}`] = item.value || ''
        })
      }
      const rootCompanyId = this.company.root_company?.id
      const companyId = this.company.id
      let url = `#${this.serialize(params, null)}`
      if (deviceType.isWeChat) {
        const query = this.$route.query
        const queryArr = []
        for (const key in query) {
          queryArr.push(`${key}=${query[key]}`)
        }
        if (queryArr.length > 0) {
          url = `?${queryArr.join('&')}${url}`
        }
        if (this.$route.fullPath.indexOf('wechatShare=1') < 0) {
          if (url.startsWith('?')) {
            url = `&${url.substr(1)}`
          }
          url = `?wechatShare=1${url}`
          this.$router.push(url)
          if (deviceType.isWeChatWork) {
            configWeComShare(this.wecom_app_info, this.wxShareInfo)
          } else {
            configWxShare(this, null, rootCompanyId, companyId)
          }
          return
        }
      }
      this.$router.push(url)
      refreshShareParam(this.wxShareInfo, null, null, rootCompanyId, companyId)
    },
    showWrapper (params) {
      for (const key in params) {
        if (key === 'more-jobs-wrapper') {
          this.showMoreJobsWrapper = params[key]
          break
        }
      }
    },
    _customizedLanguage () {
      const currentCompany = this.company
      const rootCompanyId = currentCompany.root_company && currentCompany.root_company.id
      const customized = {
        language_code: '',
        only_root_company: ''
      }
      if (currentCompany) {
        if ([2435].indexOf(currentCompany.id) !== -1) { // accor
          customized.language_code = 'zh-cn'
        }
      }
      if (rootCompanyId && ([2435].indexOf(rootCompanyId) !== -1)) { // customized accor son company
        customized.only_root_company = 1
      }
      return customized
    },
    async fetchJobList (isLoadMore, customized) {
      if (this.isSearching) {
        return
      }
      this.isSearching = true
      try {
        if (this.hasSetHashParams === true) {
          this.setQueryParams(customized)
        }
        if (isLoadMore === false) {
          this.pageNum = 1
          this.jobList = []
        }
        /** ***special logic for customized company *******/
        const customizedInfo = this._customizedLanguage()
        const languageCode = customizedInfo.language_code
        const onlyRootCompany = customizedInfo.only_root_company

        const companyId = this.companyId
        const params = {
          language_code: languageCode || null,
          only_root_company: onlyRootCompany || null,
          page: this.pageNum,
          company_id: companyId,
          keywords: this.search.keywords,
          type: this.search.type,
          job_industry_id: this.search.jobIndustryId,
          job_type_id: this.search.jobTypeId,
          job_salary_id: this.search.jobSalaryId,
          job_work_time_id: this.search.jobWorkTimeId,
          role_type: this.search.roleType,
          c_lng: this.search.lng,
          c_lat: this.search.lat,
          order_by: this.search.orderBy,
          area_city_id: this.search.areaCityId,
          area_region_id: this.search.areaRegionId,
          area_id: this.search.areaId,
          only_referral: this.search.refj === '1' ? 1 : null,
          jtitle: this.search.jtitle,
          ip_city_name: this.hasSetHashParams ? null : this.search.ipCityName,
          jid: this.search.jobIds
        }
        if (this.search.customFilters && this.search.customFilters.length > 0) {
          _.forEach(this.search.customFilters, item => {
            params[`custom_filter_${item.id}`] = item.value
          })
        }

        this.showLoading = true
        this.loadingCycle = true
        this.hasJobs = true
        if (params.keywords) {
          this.showJobs = false
        } else {
          this.showJobs = true
        }
        if (this.companyDataLoader) {
          await this.companyDataLoader
        }
        const resp = Optional.ofNullable(await this.searchCompanyJobList(params))
          .map(item => item)
          .orElse({})
        this.isLastPage = resp.isLastPage
        const totalCount = resp.data.length
        let respData = resp.data
        const filterCurrentCity = resp.filter_current_city
        const isFlatCompany = this.job_list_type === 'flat'
        if (isFlatCompany && !resp.isLastPage) {
          // bind event to load more job when page move to bottom
          window.addEventListener('scroll', this.scrollBottom)
        }

        if (totalCount !== 0) {
          if (!this.hasSetHashParams && filterCurrentCity) {
            this.respFilterCurrentCity = filterCurrentCity
            this.setFilterCityName()
          } else {
            this.respFilterCurrentCity = null
          }
          this.hasSetHashParams = true
          this.search.ipCityName = null
          if (this.company.id === 87 && respData.length > 1) {
            respData = respData.sort(this.sortJsonLocation)
            // special data for apple
            const kuimingpk = 246
            const kunmingData = respData.find(item => item.pk === kuimingpk)
            const restData = respData.filter(item => item.pk !== kuimingpk)
            respData = _.union([kunmingData], restData)
          }
          this.hasJobs = true
        } else {
          if (!(isFlatCompany && this.pageNum !== 1)) {
            this.hasJobs = false
          }
        }
        if (this.job_list_type === 'customed') {
          this.showJobs = false
        }
        if (isLoadMore === true) {
          for (const item of respData) {
            this.jobList.push(item)
          }
        } else {
          this.jobList = respData
        }
        this.resetSelectedJobs()
      } finally {
        this.showLoading = false
        this.loadingCycle = false
        this.isSearching = false
      }
    },
    onMenuIconClick () {
      if (this.showNavBar) {
        this.showNavBar = false
      } else {
        this.showNavBar = true
      }
    },
    resetSelectedJobs () {
      const selected = {}
      _.forEach(this.jobList, job => {
        selected[job.pk] = this.batchSharing.isSelectAll
      })
      this.batchSharing.selected = selected
    },
    onMenuShareBtnClick () {
      if (this.batchSharing.enable) {
        this.batchSharing.enable = false
      } else {
        this.batchSharing.isSelectAll = false
        this.resetSelectedJobs()
        this.batchSharing.enable = true
      }
    },
    handleCancelShareBtnClick () {
      this.onMenuShareBtnClick()
    },
    handleShareBtnClick () {
      if (!this.batchSharing.hasSelectAny) {
        return
      }
      let shareJobs = []
      let shareLink = this.referralShareUrl || this.formatShareUrl(window.location.pathname)
      if (this.batchSharing.isSelectAll) {
        shareLink += window.location.hash
        shareJobs = this.jobList
      } else {
        const selectedJobId = []
        const hash = window.location.hash || '#jid='
        _.forEach(this.batchSharing.selected, (selected, jobId) => {
          if (selected) {
            selectedJobId.push(jobId)
          }
        })
        shareJobs = _.filter(this.jobList, job => this.batchSharing.selected[job.pk])
        shareLink += hash.replace(/([#&])jid=[\d%C]*/, `$1jid=${encodeURIComponent(selectedJobId.join(','))}`)
        if (!shareLink.includes('jid=')) {
          shareLink += `&jid=${encodeURIComponent(selectedJobId.join(','))}`
        }
      }
      refreshShareParam(this.wxShareInfo, shareLink, null, this.company.root_company?.id, this.company.id)
      this.sharePopup.link = shareLink
      this.sharePopup.isShareAllJobs = this.batchSharing.isSelectAll
      this.sharePopup.shareJobs = shareJobs
      this.sharePopup.show = true
    },
    sortJsonLocation (a, b) {
      if (/^\b/.test(a.i18n_city_name)) {
        return a.i18n_city_name.toLowerCase().localeCompare(b.i18n_city_name.toLowerCase())
      }
      return a.pinyin_keyword.localeCompare(b.pinyin_keyword)
    },
    clearSearch () {
      this.pageNum = 1
      this.search.keywords = null
      this.search.keywords = null
      this.search.type = null
      this.search.jobIndustryId = null
      this.search.jobTypeId = null
      this.search.jobSalaryId = null
      this.search.jobWorkTimeId = null
      this.search.roleType = null
      this.search.orderBy = null
      this.search.areaCityId = null
      this.search.areaRegionId = null
      this.search.areaId = null
      this.jobList = []
      this.pageNum = 1
      if (this.search.customFilters && this.search.customFilters.length > 0) {
        _.forEach(this.search.customFilters, item => {
          item.value = null
        })
      }
      this.fetchJobList()
    },
    async scrollBottom () {
      if (this.isLastPage) {
        return
      }
      // document.body.scrollTop can not work on pc, but mobile can
      const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop)
      const distance = scrollTop - this.$el.clientHeight + window.innerHeight
      if (Math.abs(distance) <= 100 && this.showLoading === false) {
        this.showLoading = true
        this.pageNum += 1
        await this.fetchJobList(true)
      }
    },
    onSearchBtnIconClick () {
      window.location.href = '#action=search'
      // _showCompanyPage(2)
      this.showMoreJobsWrapper = false
      const listSearch = this.$refs.ListSearch
      const jobListContent = this.$refs.jobListContent
      listSearch.showCompanyJobListWrapper = true
      const listSearchClassList = listSearch.$el.classList
      listSearchClassList.remove('animated')
      listSearchClassList.add('animated', 'fadeInUpBig')
      const jobListContentClassList = jobListContent.classList
      jobListContentClassList.remove('animated')
      jobListContentClassList.add('animated', 'fadeInUpBig')
    },
    // async checkStarbucksSSO () {
    //   const userAgent = navigator.userAgent
    //   if (userAgent.indexOf('Joywok') !== -1) {
    //     let jw = window.jw
    //     if (!jw) {
    //       await require('https://www.joywok.com/public/scripts/jssdk.js')
    //       jw = window.jw
    //     }
    //     let resp = null
    //     const url = window.location.origin + this.$route.path
    //     const params = {
    //       backurl: url
    //     }
    //     if (!(this.account && this.account.id)) {
    //       resp = await this.checkAutoLogin({ params })
    //     } else {
    //       resp = await this.getJoywokConfigParams({ params })
    //     }

    //     try {
    //       jw.ready = () => {
    //         if (!(this.account && this.account.id)) {
    //           jw.getAuthCode({
    //             url: url
    //           }, {
    //             success: async (data) => {
    //               await this.getEmployeeInfo({ code: data.code, params })
    //               this.$parent.routerAlive = false
    //               this.getSessionAccountInfo().then(res => {
    //                 this.$parent.routerAlive = true
    //               })
    //             }
    //           })
    //         }

    //         jw.setFuncBtns([
    //           {
    //             type: 2
    //           }
    //         ])
    //       }
    //       window.onJwNavBtnClick = async (data) => {
    //         jw.shareURL({
    //           url: this.wxShareInfo.normal_share_url || window.location.href,
    //           title: this.wxShareInfo.title.replace('&#39;', "'"),
    //           cover: window.location.origin + this.wxShareInfo.logo
    //         }, {
    //           success: function (ret) {}
    //         })
    //       }

    //       jw.config({
    //         debug: false,
    //         appid: resp.appid,
    //         corpid: resp.corpid,
    //         signature: resp.signature,
    //         timestamp: resp.timestamp,
    //         nonceStr: resp.nonceStr,
    //         secretSignature: resp.secret_signature
    //       })
    //     } catch (err) {
    //       // eslint-disable-next-line no-console
    //       console.error(err)
    //     }
    //   }
    // },
    async configReferral () {
      const companyId = parseInt(this.companyId)
      if ((this.account?.id || this.softUser?.id) && companyId) {
        const referralUrl = await this.startListReferral({ companyId })
        this.referralShareUrl = this.formatShareUrl(referralUrl)
      }
    },
    formatShareUrl (url) {
      if (!url.includes('http')) {
        url = window.location.origin + url
      }
      const query = this.$route.query
      const params = {
        aj_source: query.aj_source,
        aj_code: query.aj_code
      }
      return addQueryInPath(url, params, true)
    },
    onVideoNavigationShowChange (value) {
      this.hiddenChatbot = value
    },
    getActiveColorByCustomColor (customColor) {
      const luminance = computedColorLuminance(customColor)
      if (luminance < 50) {
        return '#0096cc'
      }
      return customColor
    }
  },
  watch: {
    companyId () {
      this.$parent.reloadPage()
    },
    loadedCompany () {
      this.setFilterCityName()
    },
    'batchSharing.selected': {
      deep: true,
      handler () {
        if (this.jobList.length !== 0) {
          this.batchSharing.isSelectAll = _.filter(this.batchSharing.selected).length === this.jobList.length
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/animate.min.css';
@import '~@/assets/icomoon/style.css';
.job-list {
  .search-btn-container .search-button {
    vertical-align: baseline;
  }

  .nav-bar {
    border-bottom: 1px solid #030303;
  }

  .company-job-list-loading {
    margin-top: 20px;

    .rect-loading {
      ::v-deep {
        position: unset;
        background-color: initial;
        opacity: initial;
      }
    }
  }

  .batch-sharing-container {
    display: flex;
    width: 100%;
    height: 50px;
    background: #f7f7f7;
    transition: bottom .3s;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 101;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    &.fade-enter-active {
      bottom: -50px;
    }

    &.fade-enter-to {
      bottom: 0;
    }

    &.fade-leave-to {
      bottom: -50px;
    }

    .all-job-checkbox {
      margin-left: 10px;

      ::v-deep {
        .van-checkbox__label {
          margin-left: 24px;
        }
        .van-checkbox__icon--checked {
          .van-icon {
            background-color: var(--custom-color);
            border-color: var(--custom-color);
          }
        }
      }
    }

    .share-btn-group {
      margin-right: 10px;

      .clear-btn, .share-btn {
        padding: 5px 20px;
        border-color: var(--custom-color);
      }

      .clear-btn {
        color: var(--custom-color);
      }

      .share-btn {
        color: #fff;
        background-color: var(--custom-color);

        &.disabled-btn {
          cursor: not-allowed;
          border-color: #c8c9cc;
          background-color: #c8c9cc;
        }
      }
    }
  }

  .chatbot {
    ::v-deep #btnDialogToggle {
      width: 60px;
      height: 60px;
    }
  }

  .video-navigation {
    z-index: 101;

    &.has-chatbot {
      margin-right: 95px;
    }
  }
}

#main {
  .costum-mobile-footer {
    .view.col-2 {
      &.full-line {
        width: 100%;
      }
    }
  }
}
</style>
